import React, {useEffect, useState} from 'react'
import {
    isActive,
    isInactive, isLowWork,
    isUnavailable,
    sortByHosts,
    sortByJobs,
    sortByLastNews,
    sortByName,
    sortByUsers,
    sortProjects
} from "../../util";
import {getProjects} from "../../services";
import {PageHeader, ProjectCard} from "../../components";

const Projects = () => {
    const [projects, setProjects] = useState([])
    const [activeProjects, setActiveProjects] = useState([])
    const [lowWorkProjects, setLowWorkProjects] = useState([])
    const [inactiveProjects, setInactiveProjects] = useState([])
    const [unavailableProjects, setUnavailableProjects] = useState([])
    const [sortOrder, setSortOrder] = useState('lastNews')
    const [type, setType] = useState('active')

    const changeSort = (event) => {
        setSortOrder(event.target.value)
    }

    const changeType = (event) => {
        setType(event.target.value)
    }

    const sortFunction = (name) => {
        if (name === 'lastNews') {
            return sortByLastNews
        } else if (name === 'numUsers') {
            return sortByUsers
        } else if (name === 'numHosts') {
            return sortByHosts
        } else if (name === 'numJobs') {
            return sortByJobs
        }
        return sortByName
    }

    useEffect(() => {
        setActiveProjects(projects.filter(project=>isActive(project)))
        setLowWorkProjects(projects.filter(project=>isLowWork(project)))
        setInactiveProjects(projects.filter(project=>isInactive(project)))
        setUnavailableProjects(projects.filter(project=>isUnavailable(project)))
    }, [projects])

    useEffect( () => {
        getProjects()
            .then( (response) => {
                const returnedProjects = response.data.filter(project => project.type === "Project")
                setProjects(sortProjects(returnedProjects, sortFunction(sortOrder)))
            })
    }, [sortOrder])

    let displayProjects
    let description
    if (type === 'limited') {
        displayProjects = lowWorkProjects.map((project) => {
            return <ProjectCard key={project.id} project={project} />
        })
        description = 'Displaying projects that have had few or no jobs available to send for at least a day'
    } else if (type === 'inactive') {
        displayProjects = inactiveProjects.map((project) => {
            return <ProjectCard key={project.id} project={project} />
        })
        description = 'Displaying projects whose scheduler has been stopped for at least a day'
    } else if (type === 'unavailable') {
        displayProjects = unavailableProjects.map((project) => {
            return <ProjectCard key={project.id} project={project} />
        })
        description = 'Displaying projects that we have not been able to connect to recently'
    } else {
        displayProjects = activeProjects.map((project) => {
            return <ProjectCard key={project.id} project={project} />
        })
        description = ''
    }

    return (
        <div className="container">
            <PageHeader title="Projects" />
            <div className="row mb-2">
                <div className="col"></div>
                <div className="col-sm-auto mb-1 d-flex justify-content-end">
                    <select className="form-select" onChange={changeType} value={type}>
                        <option value='active'>Active projects</option>
                        <option value='limited'>Projects with limited work</option>
                        <option value='inactive'>Inactive projects</option>
                        <option value='unavailable'>Offline projects</option>
                    </select>
                </div>
                <div className="col-sm-auto mb-1 d-flex justify-content-end">
                    <select className="form-select" onChange={changeSort} value={sortOrder}>
                        <option value='name'>by name</option>
                        <option value='lastNews'>by recent news</option>
                        <option value='numUsers'>by most active users</option>
                        <option value='numHosts'>by most active hosts</option>
                        <option value='numJobs'>by most available jobs</option>
                    </select>
                </div>
            </div>
            <div className="row gx-3 gy-3 mb-4">
                {displayProjects}
            </div>
            <div className="d-flex">
                <span>{description}</span>
            </div>
        </div>
    )
}

export default Projects
